import React from 'react'

const WhyWePage = () => {
    return (
        <section id='whyWe'>
            <div className="text-center">
                <hr />
                {/* <section className="bg-white py-8">
                    <h2 className="text-4xl font-bold">Numbers don't lie</h2>
                    <div className="flex flex-wrap justify-center mt-4">
                        <div className="flex w-1/2 sm:w-1/5 md:w-1/5 p-4 gap-4">
                            <p className="text-xl font-bold">15L+</p>
                            <p className="text-sm">Amenity bookings made annually</p>
                        </div>
                        <div className="flex w-1/2 sm:w-1/5 md:w-1/5 p-4 gap-4">
                            <p className="text-xl font-bold">3000Cr</p>
                            <p className="text-sm">Annual dues processed</p>
                        </div>
                        <div className="flex w-1/2 sm:w-1/5 md:w-1/5 p-4 gap-4">
                            <p className="text-xl font-bold">60L+</p>
                            <p className="text-sm">Helpdesk tickets raised annually</p>
                        </div>
                        <div className="flex w-1/2 sm:w-1/5 md:w-1/5 p-4 gap-4">
                            <p className="text-xl font-bold">100Cr+</p>
                            <p className="text-sm">Visitor entries validated annually</p>
                        </div>
                    </div>
                </section> */}
                <section className="bg-blue-900 py-8 lg:px-40 px-8">
                    <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-white">Why Choose Smart Chokidar?</h2>
                    <div className="flex flex-wrap justify-center">
                        {/* Card 1 */}
                        <div className="w-full lg:w-1/3 p-4">
                            <div className="custom-why-choose-card">
                                <div className="custom-why-choose-icon"><i className="fa fa-users"></i></div>
                                <h3 className="custom-why-choose-title">Management of Visitor Access</h3>
                                <p className="custom-why-choose-description">
                                Successful management of visitor access is essential to maintaining security, smooth operation, and delivering a good experience for everyone who enters a facility.
                                </p>
                            </div>
                        </div>

                        {/* Card 2 */}
                        <div className="w-full lg:w-1/3 p-4">
                            <div className="custom-why-choose-card">
                                <div className="custom-why-choose-icon"><i className="fa fa-user-secret"></i></div>
                                <h3 className="custom-why-choose-title">Secure Messaging Platforms</h3>
                                <p className="custom-why-choose-description">
                                As more and more personal and sensitive data are being posted online, it is imperative that messaging websites offer privacy and security from unauthorized access.
                                </p>
                            </div>
                        </div>

                        {/* Card 3 */}
                        <div className="w-full lg:w-1/3 p-4">
                            <div className="custom-why-choose-card">
                                <div className="custom-why-choose-icon"><i className="fa fa-bell"></i></div>
                                <h3 className="custom-why-choose-title">Instant Notifications and Alerts</h3>
                                <p className="custom-why-choose-description">
                                Instant notifications and alerts are central to keeping people and organizations up to date, so they are able to respond quickly to upcoming events, shifts, or critical updates.
                                </p>
                            </div>
                        </div>

                    </div>
                    <div className="flex flex-wrap justify-center">

                        {/* Card 4 */}
                        <div className="w-full lg:w-1/3 p-4">
                            <div className="custom-why-choose-card">
                                <div className="custom-why-choose-icon"><i className="fa fa-area-chart"></i></div>
                                <h3 className="custom-why-choose-title">Insights and Analytics</h3>
                                <p className="custom-why-choose-description">
                                In the age of information, data is among the most important assets for an organization. Data in its raw form is of little value.
                                </p>
                            </div>
                        </div>

                        {/* Card 5 */}
                        <div className="w-full lg:w-1/3 p-4">
                            <div className="custom-why-choose-card">
                                <div className="custom-why-choose-icon"><i className="fas fa-money-bill-wave"></i></div>
                                <h3 className="custom-why-choose-title">Easy billing</h3>
                                <p className="custom-why-choose-description">
                                By automating the billing cycle, companies can cut down on manual errors, lower administrative expenses, and enhance general operational efficiency.
                                </p>
                            </div>
                        </div>

                        {/* Card 6 */}
                        <div className="w-full lg:w-1/3 p-4">
                            <div className="custom-why-choose-card">
                                <div className="custom-why-choose-icon"><i className="fa fa-check-circle"></i></div>
                                <h3 className="custom-why-choose-title">Smooth Issue Fix</h3>
                                <p className="custom-why-choose-description">
                                Regardless of whether it's a technical issue, service issue, or customer grievance, resolving issues timely instills trust and strengthens customer satisfaction.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    )
}

export default WhyWePage